<script>
import { Line } from 'vue-chartjs';
import * as chartFormatting from '@/data/chart-formatting.js';
import debounce from 'lodash/debounce';

const data = [
  [
    0,
    0,
    0,
    1500000,
    3000000,
    6000000,
    8500000,
    10000000,
    13000000,
    14500000,
    16500000,
    18500000,
    30000000,
    37500000,
    45000000,
    52500000,
    70000000,
    87500000,
    105000000,
    125000000,
    145000000,
    166000000,
    187000000,
    208000000,
    229000000,
    244000000,
    251500000,
    251500000,
    251500000,
    251500000,
    251500000,
    251500000,
    255400000,
    259900000,
    279900000,
    300000000,
    318000000,
    328000000,
    335500000,
    342500000,
    349500000,
    356500000,
    363500000,
    370500000
  ]
];
const chartSpec = {
  labels: chartFormatting.xLabels,
  datasets: [
    {
      backgroundColor: '#35A0CC',
      borderColor: '#43A7D0',
      borderWidth: 1,
      data: data[0],
      lineTension: 0.4,
      pointRadius: 0,
      pointHoverRadius: 0
    }
  ]
};
const chartOptions = {
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 500
    }
  },
  animation: {
    easing: chartFormatting.animationEasing,
    duration: chartFormatting.animationDuration
  },
  legend: {
    display: false
  },
  tooltips: {
    enabled: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          padding: 20,
          autoSkip: true,
          beginAtZero: false,
          fontColor: '#424242',
          fontFamily: chartFormatting.labelFontFamily,
          fontSize: 14,
          lineHeight: 2,
          maxTicksLimit: 10,
          callback: function (val) { // Format the dollars on the Y-axis
            if (val >= 1000000000) { // $x.xB
              return '$' + (val / 1000000000) + 'B';
            } else if (val >= 1000000) { // $x.xM
              return '$' + (val / 1000000) + 'M';
            } else { // $xx,xxx
              return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
          }
        },
        gridLines: {
          drawTicks: false,
          display: false
        }
      }
    ],
    xAxes: [
      {
        gridLines: {
          zeroLineColor: 'transparent'
        },
        ticks: chartFormatting.xLabelFormat
      }
    ]
  }
};

export default {
  name: 'CumulativeDividendsChart',
  extends: Line,
  data: function () {
    return {
      chartOptions: chartOptions
    };
  },
  mounted () {
    this.resize();
    document.addEventListener('aos:in', this.aosChartEvent);
    this.handleDebouncedResize = debounce(this.resize, 100);
    window.addEventListener('resize', this.handleDebouncedResize);
  },
  beforeDestroy () {
    document.removeEventListener('aos:in', this.aosChartEvent);
    window.removeEventListener('resize', this.handleDebouncedResize);
  },
  methods: {
    aosChartEvent: function (event) {
      const eventDetail = (event.detail.detail !== undefined) ? event.detail.detail : event.detail;
      if (!eventDetail.classList.contains('chart-container-outer') ||
        !eventDetail.classList.contains('chart-container-cumulative-dividends')) return;
      document.removeEventListener('aos:in', this.aosChartEvent);
      this.render();
    },
    render: function () {
      this.renderChart(chartSpec, chartOptions);
    },
    resize: function () {
      /* eslint-disable */
      if ($(window).width() <= 400) {
        chartOptions.layout.padding.bottom = 120;
      } else if ($(window).width() >= 401 && $(window).width() < 500) {
        chartOptions.layout.padding.bottom = 180;
      } else if ($(window).width() >= 501 && $(window).width() < 600) {
        chartOptions.layout.padding.bottom = 250;
      } else if ($(window).width() >= 601 && $(window).width() < 749) {
        chartOptions.layout.padding.bottom = 300;
      } else if ($(window).width() >= 750 && $(window).width() < 999) {
        chartOptions.layout.padding.bottom = 400;
      } else if ($(window).width() >= 1000) {
        chartOptions.layout.padding.bottom = 500;
      }
      /* eslint-enable */
      this.render();
    }
  }
};
</script>
